/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pitch_Ai_BodyInputs */



/**
* | output |
* | --- |
* | "Where fixed rules fall short, AI suggests changes that make the text easier to read, without changing its style or tone." |
*
* @param {Pitch_Ai_BodyInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const pitch_ai_body = /** @type {((inputs?: Pitch_Ai_BodyInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pitch_Ai_BodyInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Where fixed rules fall short, AI suggests changes that make the text easier to read, without changing its style or tone.")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Där fasta regler inte räcker till föreslår AI ändringar som gör texten lättare att läsa, utan att ändra stil och ton.")
	return /** @type {LocalizedString} */ ("Der faste regler ikke strekker til, foreslår kunstig intelligens endringer som gjør teksten lettere å lese, uten å endre stil og tone.")
});